






import { defineComponent } from '@vue/composition-api';
import TeaserText from '@/components/storyblok/TeaserText.vue';
import ImageCaption from '@/components/storyblok/ImageCaption.vue';
import ContentContainer from '@/components/storyblok/ContentContainer.vue';
import EduTitle from '@/components/storyblok/EduTitle.vue';
import RichText from '@/components/storyblok/RichText.vue';
import DownloadButton from '@/components/storyblok/DownloadButton.vue';

import TrackInfoHeading from '@/components/storyblok/track-info/Heading.vue';
import TrackInfoImage from '@/components/storyblok/track-info/Image.vue';
import TrackInfoText from '@/components/storyblok/track-info/Text.vue';
import TrackInfoVideo from '@/components/storyblok/track-info/Video.vue';

export default defineComponent({
  name: 'TrackInfoPage',
  props: { blok: { type: Object } },
  components: { TeaserText, ImageCaption, ContentContainer, EduTitle, RichText, DownloadButton, TrackInfoHeading, TrackInfoImage, TrackInfoText, TrackInfoVideo },
});
